export default __webpack_public_path__ + "static/media/tomato_slice.cabdbca8.png";